import Joi from "joi";

const objectIdPattern = /^[0-9a-fA-F]{24}$/;

/**
 * Validation schema for creating an assignment
 */
export const createAssignmentValidation = Joi.object({
  semesterId: Joi.string().regex(objectIdPattern).required().messages({
    "string.pattern.base": "Invalid semester ID format",
    "any.required": "Semester ID is required",
  }),

  classId: Joi.string().regex(objectIdPattern).required().messages({
    "string.pattern.base": "Invalid class ID format",
    "any.required": "Class ID is required",
  }),

  title: Joi.string().trim().min(3).max(200).required().messages({
    "string.min": "Title must be at least 3 characters",
    "string.max": "Title cannot exceed 200 characters",
    "any.required": "Title is required",
  }),

  description: Joi.string().trim().max(2000).allow("").messages({
    "string.max": "Description cannot exceed 2000 characters",
  }),

  totalMarks: Joi.number().integer().min(1).max(1000).required().messages({
    "number.min": "Total marks must be at least 1",
    "number.max": "Total marks cannot exceed 1000",
    "any.required": "Total marks is required",
  }),

  deadline: Joi.date().iso().greater("now").required().messages({
    "date.greater": "Deadline must be in the future",
    "any.required": "Deadline is required",
  }),

  allowLateSubmission: Joi.boolean().default(false),

  lateSubmissionPenalty: Joi.number().integer().min(0).max(100).messages({
    "number.min": "Penalty cannot be negative",
    "number.max": "Penalty cannot exceed 100%",
  }),
});

/**
 * Validation schema for updating an assignment
 */
export const updateAssignmentValidation = Joi.object({
  title: Joi.string().trim().min(3).max(200).messages({
    "string.min": "Title must be at least 3 characters",
    "string.max": "Title cannot exceed 200 characters",
  }),

  description: Joi.string().trim().max(2000).allow("").messages({
    "string.max": "Description cannot exceed 2000 characters",
  }),

  totalMarks: Joi.number().integer().min(1).max(1000).messages({
    "number.min": "Total marks must be at least 1",
    "number.max": "Total marks cannot exceed 1000",
  }),

  deadline: Joi.date().iso().greater("now").messages({
    "date.greater": "Deadline must be in the future",
  }),

  allowLateSubmission: Joi.boolean(),

  lateSubmissionPenalty: Joi.number().integer().min(0).max(100).messages({
    "number.min": "Penalty cannot be negative",
    "number.max": "Penalty cannot exceed 100%",
  }),
});

/**
 * Validation schema for grading an assignment submission
 */
export const gradeAssignmentValidation = Joi.object({
  marksObtained: Joi.number().min(0).required().messages({
    "number.min": "Marks cannot be negative",
    "any.required": "Marks obtained is required",
  }),

  feedback: Joi.string().trim().max(1000).allow("").messages({
    "string.max": "Feedback cannot exceed 1000 characters",
  }),
});

/**
 * Validation schema for submitting an assignment (student)
 */
export const submitAssignmentValidation = Joi.object({
  textContent: Joi.string().trim().max(5000).allow("").messages({
    "string.max": "Text content cannot exceed 5000 characters",
  }),
});
